import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import {
  FactNames,
  RuleOperators,
  ConditionDto,
} from '@marketplace-web/escrow-pricing/escrow-pricing-data'

type Props = {
  factName: FactNames
  stringTransformer?: (val: string) => string
  numberTransformer?: (val: number) => string | number
  ruleConditions: Array<ConditionDto>
}

const usePriceRuleConditionFormatter = ({
  ruleConditions,
  factName,
  stringTransformer,
  numberTransformer,
}: Props) => {
  const translate = useTranslate('available_discounts')

  const conditionsList = ruleConditions.filter(item => item.fact === factName)

  const getOperatorPrefix = (operator: RuleOperators) => {
    if ([RuleOperators.Equal, RuleOperators.In].includes(operator)) {
      return ''
    }

    return `${translate(`price_rule_data.operator.${operator}`)} `
  }

  const transformSingleValue = (valueItem: string | number) => {
    if (typeof valueItem === 'string') {
      return stringTransformer?.(valueItem) || valueItem
    }

    if (typeof valueItem === 'number') {
      return numberTransformer?.(valueItem) || valueItem
    }

    return valueItem
  }

  const formatValue = (condition: ConditionDto) => {
    if (condition.value === null) return null

    const operatorPrefix = getOperatorPrefix(condition.operator)

    if (Array.isArray(condition.value)) {
      const formattedMultiValue = condition.value.map(transformSingleValue).join(' / ')

      return `${operatorPrefix}${formattedMultiValue}`
    }

    return `${operatorPrefix}${transformSingleValue(condition.value)}`
  }

  return conditionsList.map(formatValue)
}

export default usePriceRuleConditionFormatter
